import { useContext } from 'react';
import { ProfileContext } from 'application/adapters/context/Profile';
import { DataScript } from 'ui/components/3-organisms/DataScript';

export const UserDataFeature: React.FC = () => {
	const { profile } = useContext(ProfileContext);
	if (!profile) return null;

	const data = {
		id: profile.membership?.id,
		name: `${profile.firstName} ${profile.lastName}`,
		workplace: profile.employment?.employer?.name,
		local_branch: profile.branch?.name,
		agreement_code: profile.employment?.employer?.agreement?.id,
	};

	return <DataScript id="user-profile-data" strategy="afterInteractive" variableName="userProfile" data={data} />;
};
